import React from "react";
import Typography, { ETypo } from "@Front/Components/DesignSystem/Typography";
import ConfirmModal from "@Front/Components/DesignSystem/Modal/ConfirmModal";
import classes from "./classes.module.scss";
import type { StepPasswordCopy } from "./useStepPasswordCopy";

type Props = {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
	copy: Pick<StepPasswordCopy, "modalTitle" | "modalBody" | "modalConfirm" | "modalCancel">;
};

export function StepPasswordForgotModal(props: Props): React.JSX.Element {
	const { isOpen, onClose, onConfirm, copy } = props;
	return (
		<ConfirmModal
			isOpen={isOpen}
			onClose={onClose}
			title={copy.modalTitle}
			confirmButton={{
				label: copy.modalConfirm,
				onClick: onConfirm,
			}}
			cancelButton={{
				label: copy.modalCancel,
			}}>
			<div className={classes["modal-content"]}>
				<Typography typo={ETypo.TEXT_MD_REGULAR} className={classes["text"]}>
					{copy.modalBody}
				</Typography>
			</div>
		</ConfirmModal>
	);
}
